module.exports = __webpack_public_path__ + "img/arrow_down.a984a986.svg";